<template>
    <div v-if="selectedFeaturedBlock !== null" aria-live="polite">
        <md-card class="workflow-library-info">
            <div>
                <md-card-actions>
                    <md-button
                        :md-ripple="false"
                        class="md-raised md-accent" 
                        @click.stop="loadFeaturedBlock(selectedFeaturedBlock.id, selectedFeaturedBlock.title)">
                        Load Workflow
                    </md-button>
                </md-card-actions>                    
                <md-card-header>
                    <md-card-header-text>
                        <div class="md-headline">{{ selectedFeaturedBlock.title }}</div>
                    </md-card-header-text>
                </md-card-header>
                <md-card-media>
                    <img
                        :src="require(`@/assets/featured-workflows/${selectedFeaturedBlock.img}`)"
                        :alt="selectedFeaturedBlock.title"
                    />
                </md-card-media>
                <md-card-content>
                    <p>{{ selectedFeaturedBlock.desc }}</p>
                </md-card-content>
            </div>
        </md-card>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { AnalyticsService } from "@/services/analytics.service";
import { GA_EVENTS } from "@/constants/gaConstants.js";

export default {
    name: 'FeaturedBlockViewer',
    props: {
        selectedFeaturedBlock: {
            type: Object,
            required: false
        }
    },
    methods: {
        loadFeaturedBlock(id, title) {
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.LOAD_EXAMPLE_WORKFLOW, null, {'title': title });
            this.$emit("featured-block", id);
        },
    }
}
</script>

<style lang="scss" scoped>
    .workflow-library-info {
        &.md-card {
            box-shadow: none;
        }

        .md-card-header, .md-card-content {
            padding-left: 0;
            padding-right: 0;
        }
        .md-card-media {
            img {
                width: 300px;
                height: auto;
            }
        }
    }
    
</style>